/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/jsx-filename-extension */
import { AuditOutlined } from '@ant-design/icons';
import * as AutoridadesDeterminantes from 'views/PAE/AutoridadesDeterminantes';
import * as Ejecuciones from 'views/PAE/ConsultaDeEjecuciones';
import * as Ejecutores from 'views/PAE/Ejecutores';
import * as EstadosDelCredito from 'views/PAE/EstadosDelCredito';
import * as EstatusDeEjecuciones from 'views/PAE/EstatusDeEjecuciones';
import * as MotivosDeCancelacion from 'views/PAE/MotivosDeCancelacion';
import * as OrigenesDeCredito from 'views/PAE/OrigenesDeCredito';
import * as TiposDeCredito from 'views/PAE/TiposDeCredito';
import * as UnidadesEjecutoras from 'views/PAE/UnidadesEjecutoras';
import * as ZonasDeDiligencia from 'views/PAE/ZonasDeDiligencia';
import * as CreditosFiscales from 'views/PAE/CreditosFiscales';
import * as GenerarEjecuciones from 'views/PAE/GenerarEjecuciones';
// import Blank from 'routes/Blank';

export default {
  title: 'Reportes Morosos',
  icon: () => <AuditOutlined />,
  showInSidebar: true,
  type: 'private',
  children: [
    {
      title: 'Generador de Reportes Morosos',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: GenerarEjecuciones.default,
      permissionConfig: GenerarEjecuciones.permissionConfig,
    },
    {
      title: 'Consulta de Reportes Morosos',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: Ejecuciones.default,
      permissionConfig: Ejecuciones.permissionConfig,
    },
    {
      title: 'Creditos Fiscales',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: CreditosFiscales.default,
      permissionConfig: CreditosFiscales.permissionConfig,
    },
    {
      title: 'Catálogos de reportes',
      icon: null,
      showInSidebar: true,
      type: 'private',
      children: [
        {
          title: 'Origenes de Crédito',
          icon: null,
          showInSidebar: true,
          type: 'private',
          component: OrigenesDeCredito.default,
          permissionConfig: OrigenesDeCredito.permissionConfig,
        },
        {
          title: 'Estatus de Reporte',
          icon: null,
          showInSidebar: true,
          type: 'private',
          component: EstatusDeEjecuciones.default,
          permissionConfig: EstatusDeEjecuciones.permissionConfig,
        },
        {
          title: 'Ejecutores',
          icon: null,
          showInSidebar: true,
          type: 'private',
          component: Ejecutores.default,
          permissionConfig: Ejecutores.permissionConfig,
        },
        {
          title: 'Motivos de Cancelación',
          icon: null,
          showInSidebar: true,
          type: 'private',
          component: MotivosDeCancelacion.default,
          permissionConfig: MotivosDeCancelacion.permissionConfig,
        },
        {
          title: 'Zonas de diligencia',
          icon: null,
          showInSidebar: true,
          type: 'private',
          component: ZonasDeDiligencia.default,
          permissionConfig: ZonasDeDiligencia.permissionConfig,
        },
        {
          title: 'Tipos de Crédito',
          icon: null,
          showInSidebar: true,
          type: 'private',
          component: TiposDeCredito.default,
          permissionConfig: TiposDeCredito.permissionConfig,
        },
        // Configuración Operativa
        {
          title: 'Estados del Crédito',
          icon: null,
          showInSidebar: true,
          type: 'private',
          component: EstadosDelCredito.default,
          permissionConfig: EstadosDelCredito.permissionConfig,
        },
        {
          title: 'Autoridades Determinantes',
          icon: null,
          showInSidebar: true,
          type: 'private',
          component: AutoridadesDeterminantes.default,
          permissionConfig: AutoridadesDeterminantes.permissionConfig,
        },

        // Configuración de Ejecución
        {
          title: 'Unidades Ejecutoras',
          icon: null,
          showInSidebar: true,
          type: 'private',
          component: UnidadesEjecutoras.default,
          permissionConfig: UnidadesEjecutoras.permissionConfig,
        },
      ],
    },
    // {
    //   title: 'Reportes de Ejecuciones y Créditos',
    //   icon: null,
    //   showInSidebar: true,
    //   type: 'private',
    //   component: Blank,
    // },
  ],
};
